<template lang="pug">
.mobile_terminal_my
    el-button(@click="openScan()") 扫描
</template>
    
<script>
    import { Dialog } from 'vant'
    
    export default {
      data: () => ({
        show: false,
        value: '',
        showPicker: false,
        showTeams: false,
        showApps: false,
        columns: ['杭州', '宁波', '温州', '绍兴', '湖州', '嘉兴', '金华', '衢州'],
        showPopover: false,
        // 通过 actions 属性来定义菜单选项
        actions: [
          { value: '1', text: '切换工作区' },
          { value: '2', text: '账号登出' },
        ],
        stars: [],
        dataList: [],
        editedIndex: -1,
        deleteAppDialog: false,
        deleteFormDialog: false,
        deleteFormObj: {},
        deleteAppObj: {},
        deleteText: '',
        apps: [],
        count: 0,
        appImgs: [
          'app1.png',
          'app2.png',
          'app3.png',
          'app4.png',
          'app5.png',
          'app6.png',
          'app7.png',
          'app8.png',
          'app9.png',
          'app10.png',
          'app11.png',
          'app12.png',
          'app13.png',
          'app14.png',
          'app15.png',
          'app16.png',
        ],
        formImgs: [
          'form1.png',
          'form2.png',
          'form3.png',
          'form4.png',
          'form5.png',
          'form6.png',
          'form7.png',
          'form8.png',
          'form9.png',
          'form10.png',
          'form11.png',
          'form12.png',
          'form13.png',
          'form14.png',
          'form15.png',
          'form16.png',
          'form17.png',
          'form18.png',
          'form19.png',
          'form20.png',
          'form21.png',
          'form22.png',
          'form23.png',
          'record1.png',
          'record2.png',
          'record3.png',
          'record4.png',
          'record5.png',
          'record6.png',
          'record7.png',
          'record8.png',
          'record9.png',
          'record10.png',
          'record11.png',
          'record12.png',
          'record13.png',
          'record14.png',
          'record15.png',
        ],
        schema_type: [
          { id: 'T01', name: '普通表单' },
          // { id: "T02", name: "流程表单" },
          { id: 'T03', name: '报表' },
        ],
        addFormDialog: false,
        addAppDialog: false,
        addFormImageDialog: false,
        addAppImageDialog: false,
        addFormObj: {
          formId: '',
          formName: '',
          formDesc: '',
          formType: 'T01',
          formAppID: '',
          formPicture: 'form1.png',
        },
        addAppObj: {
          formId: '',
          formName: '',
          formDesc: '',
          formPicture: 'app1.png',
        },
        teams: [],
        defaultIndex: 0,
      }),
      mounted () {
        // console.log('index mounted')
      },
      created () {
        this.handleMessage()
      },
      methods: {
        handleMessage() {
      //收到消息 
      window.addEventListener('message', (event) => {
        // console.debug(event)
        console.debug(event.data.type)
        console.debug(event.data.message)
        if (event.data.type === 'scan') {
          


        } else if (event.data.type === 'scanResult') {
          //扫描返回结果
          console.debug('收到扫码结果:', event.data);
          console.debug('收到扫码结果:', event.data.type);
          console.debug('收到扫码结果:', event.data.message);
          this.$api.WriteCode(event.data.message).then((res) => {
            if (res.status === 200) {
              this.$message({ message: '核销成功', type: 'success' })
            }
          })
          // const message = {
          //   type: 'scanResult',
          //   message: event.data.result,
          // };
          // this.sendMessage(message)

        } else if (event.data.type === 'bluetooth') {
          //打开蓝牙
          const message = {
            type: 'bluetooth',
            message: '',
          };
          this.sendMessage(message)
        } else if (event.data.type === 'bluetoothResult') {
          //蓝牙返回消息
          const message = {
            type: 'bluetoothResult',
            message: event.data.result,
          };
          this.sendMessage(message)
        } else if (event.data.type === 'toMenu') {
          //跳转到menu 
          const params = {}
          const query = {}
          params.menu_id = event.data.menu_id
          query.menu_id = event.data.query
          this.$router.push({
                name: "mobile_terminal_page",
                params: params,
                query: query,
              });   
        }
      });
    },
    sendMessage(message) {
      // 发送消息
      // window.parent.postMessage({ type: 'scanOpen', data: 'someData' }, '*');
      // window.parent.postMessage(message, '*');
      if (this.$refs.child && this.$refs.child.sendMessage) {
        this.$refs.child.sendMessage(message)
        console.debug('消息已发送:', message);
      }
    },
        openScan() {
          // this.$api.WriteCode("044328").then((res) => {
          //   if (res.status === 200) {
          //         console.log("核销成功")
          //   }
          // })
          window.parent.postMessage({ type: 'scan', data: 'someData' }, '*');
        },
        logout() {
          this.tokenS.remove();
          this.profileS.remove();
          this.teamS.remove();
          this.roleS.remove();
          this.appS.remove();
    
          this.$router.push({ name: "login" });
        },
        showAppDlg(){
          this.showApps = true
        },
        showTeamsDlg() {
          this.showTeams = true
        },
        getUserTeams () {
          this.$api.getUserTeams().then((res) => {
            if (res.status === 200) {
              this.teams = res.data
              this.teams.forEach((item, index) => {
                if (item.id === this.team.id) {
                  this.defaultIndex = index
                }
              })
            }
          })
        },
        showPhone () {
          // this.show = true;
          Dialog.confirm({
            title: '联系顾问',
            message: '021-11111111',
            confirmButtonText: '呼叫',
          })
            .then(() => {
              // on confirm
              // console.log('确定')
              window.location.href = 'tel://021-11111111'
            })
            .catch(() => {
              // on cancel
              // console.log("确定");
            })
        },
        changeApp(app) {
          const appID = app.selectedValues[0];
          this.loading = true;
          this.$api
            .getApp({ app_id: appID })
            .then((res) => {
              if (res.status === 200) {
                this.appS.set(res.data)
                this.$emit("initData")
                this.loading = false;
              }
            })
            .catch(() => {
              this.loading = false;
            });
        },  
        changeTeam (team) {
          const teamID = team.selectedValues[0];
          this.$api.changeTeam({ team_id: teamID }).then((res) => {
            if (res.status === 200) {
              const token = res.data.token;
              const user = res.data.user;
              const team = res.data.default_team;
              const role = res.data.role;
    
              this.tokenS.set(token);
              this.profileS.set(user);
              this.teamS.set(team);
              this.roleS.set(role);
              this.appS.remove();
              this.$emit("initData")
              // this.initData()
              this.showTeams = false
            }
          })
        },
        // onConfirm(value) {
        //  console.log(value);
        //  //this.value = value;
        //  this.showPicker = false;
        // },
        // 获取列表
        onSelect (action) {
          // Toast(action.value);
          if (action.value === '1') {
            this.showPicker = true
          } else if (action.value === '2') {
            // this.showPicker = true;
            this.signOut()
          }
        },
        showAddAppDialog () {
          this.addAppObj = {
            formId: '',
            formName: '',
            formDesc: '',
            formPicture: 'app1.png',
          }
          this.addAppDialog = true
        },
    
        showEditAppDialog (item) {
          this.addAppObj.formId = item.id
          this.addAppObj.formName = item.name
          this.addAppObj.formDesc = item.desc
          this.addAppObj.formPicture = item.picture
          this.addAppDialog = true
        },
        showAddFormDialog () {
          this.addFormObj = {
            formId: '',
            formName: '',
            formDesc: '',
            formType: 'T01',
            formAppID: '',
            formPicture: 'form1.png',
          }
          this.addFormDialog = true
        },
    
        showEditFormDialog (item) {
          this.addFormObj.formId = item.id
          this.addFormObj.formName = item.name
          this.addFormObj.formDesc = item.desc
          this.addFormObj.formPicture = item.picture
          this.addFormObj.formType = item.type
          this.addFormObj.formAppID = item.app_id
          this.addFormDialog = true
        },
        getStarSchema () {
          this.stars = []
          this.$api.getStarForm().then((res) => {
            if (res.status === 200) {
              // this.stars = res.data
              // this.$api.getGroupByPermission().then((res3) => {
              //  if (res3.status === 200) {
              //    res.data.forEach((item) => {
              //      res3.data.forEach((item3) => {
              //        if (item.id === item3.schema_id) {
              //          if (item3.read === 1) {
              //            this.stars.push(item)
              //          }
              //        }
              //      })
              //    })
              //  }
              // })
            }
          })
        },
        star (n, v) {
          // console.log(n);
          n.star = v
          const dataObj = {
            id: n.id,
            star: v,
          }
    
          this.$api.postStarForm(dataObj).then((res) => {
            if (res.status === 200) {
              this.getStarSchema()
              this.initData()
            }
          })
        },
        addAppImg (v) {
          this.addAppObj.formPicture = v
          this.addAppImageDialog = false
        },
        addFormImg (v) {
          this.addFormObj.formPicture = v
          this.addFormImageDialog = false
        },
        initApp () {
            // this.getStarSchema()
    
            this.loading = true
            this.$api
            .getAppsTran({ tran: this.$n.locale })
            .then((res) => {
                if (res.status === 200) {
                this.apps = res.data
                this.apps.forEach((app) => {
                    if (app.logo !== '' && app.logo !== undefined && app.logo !== null) {
                    this.$api.getFileUrl('images', app.logo).then((res2) => {
                        if (res2.status === 200) {
                        app.logo_url = res2.data.url
                        }
                    }).catch(() => {})
                    } else if (app.picture !== '' && app.picture !== undefined && app.picture !== null && app.picture.endsWith('.png')) { // with old picture
                    app.logo_url = this.$u.getAssetsFile('images/' + app.picture)
                    } else {
                    app.logo_url = ''
                    }
                })
                // console.log(this.apps)
                }
            })
            .catch(() => {
                this.loading = false
            })
        },
    
        getListData () {
          this.$api.getForm().then((res) => {
            this.dataList = res.data
          })
        },
        // 编辑表单
        editItem (item, index) {
          if (item.type === 'T03') {
            this.$router.push({
              name: 'form_report_list',
              params: {
                schema_id: item.id,
                app_id: item.app_id,
              },
            })
          } else {
            this.$router.push({
              name: 'form_list',
              params: {
                schema_id: item.id,
                app_id: item.app_id,
              },
            })
          }
        },
        // 弹窗显示
        showDeleteAppDialog (item) {
          this.deleteText = ''
          this.deleteAppObj = item
          this.deleteAppDialog = true
        },
    
        // 删除表单
        deleteForm () {
          this.$api
            .deleteForm(this.deleteFormObj.id)
            .then((res) => {
              //      this.getListData();
              this.initData()
              this.deleteFormDialog = false
              this.$message({ message: '删除成功', type: 'success' })
            })
            // eslint-disable-next-line handle-callback-err
            .catch(() => {
              // console.log(err)
            })
        },
        toDetail (item) {
          this.$router.push({
            name: 'form_design',
            params: {
              id: item.id,
            },
          })
        },
        toDetail2 (item) {
          this.$router.push({
            name: 'form_report',
            params: {
              id: item.id,
              type: 'report',
            },
          })
        },
        openApp () {
          this.$router.push({
            name: 'apps',
          })
        },
        addForm () {
          if (!this.addFormObj.formName || this.addFormObj.formName === '') {
            this.$message({ message: '名称必须填写', type: 'warning' })
            return
          }
    
          if (!this.addFormObj.formAppID || this.addFormObj.formAppID === '') {
            this.$message({ message: '应用必须选择', type: 'warning' })
            return
          }
          if (this.addFormObj.formId === '') {
            const dataObj = {
              name: this.addFormObj.formName,
              desc: this.addFormObj.formDesc,
              picture: this.addFormObj.formPicture,
              numberId: '',
              extend: [],
              kind: 'kind',
              app_id: this.addFormObj.formAppID,
              config: {
                name: this.addFormObj.formName,
                desc: this.addFormObj.formDesc,
                numberId: '',
                columns: [],
              },
              type: this.addFormObj.formType,
            }
    
            if (this.addFormObj.formType === 'T03') {
              this.$api.postForm(dataObj).then((res) => {
                if (res.status === 200) {
                  // this.$message({ message: '创建成功', type: 'success' })
                  const schemaID = res.data.id
                  this.$router.push({
                    name: 'form_report',
                    params: { id: schemaID },
                  })
                }
              })
            } else {
              this.$api.postForm(dataObj).then((res) => {
                if (res.status === 200) {
                  // this.$message({ message: '创建成功', type: 'success' })
                  const schemaID = res.data.id
                  this.$router.push({
                    name: 'form_design',
                    params: { id: schemaID },
                  })
                }
              })
            }
          } else {
            const dataObj = {
              id: this.addFormObj.formId,
              name: this.addFormObj.formName,
              desc: this.addFormObj.formDesc,
              picture: this.addFormObj.formPicture,
            }
    
            this.$api
              .putInfoForm(
                this.addFormObj.formId,
                dataObj,
                this.addFormObj.formAppID
              )
              .then((res) => {
                if (res.status === 200) {
                  // const schemaID = res.data.id
                  // this.$router.push({
                  //  name: "form_report",
                  //  params: { id: schemaID },
                  // });
                  this.addFormDialog = false
                  this.initData()
                  this.$message({ message: '修改表单成功', type: 'success' })
                }
              })
          }
        },
        addApp () {
          if (!this.addAppObj.formName || this.addAppObj.formName === '') {
            this.$message({ message: '名称必须填写', type: 'warning' })
            return
          }
          if (this.addAppObj.formId === '') {
            const dataObj = {
              name: this.addAppObj.formName,
              desc: this.addAppObj.formDesc,
              picture: this.addAppObj.formPicture,
              numberId: '',
              extend: [],
              kind: 'kind',
              config: {
                name: this.addAppObj.formName,
                desc: this.addAppObj.formDesc,
                numberId: '',
                columns: [],
              },
            }
            this.$api.postApp(dataObj).then((res) => {
              if (res.status === 200) {
                this.addAppDialog = false
    
                this.initData()
                this.$message({ message: '创建成功', type: 'success' })
              }
            })
          } else {
            const dataObj = {
              id: this.addAppObj.formId,
              name: this.addAppObj.formName,
              desc: this.addAppObj.formDesc,
              picture: this.addAppObj.formPicture,
              numberId: '',
              extend: [],
              kind: 'kind',
              config: {
                name: this.addAppObj.formName,
                desc: this.addAppObj.formDesc,
                numberId: '',
                columns: [],
              },
            }
    
            this.$api.putApp(dataObj).then((res) => {
              if (res.status === 200) {
                this.addAppDialog = false
    
                this.initData()
                this.$message({ message: '修改成功', type: 'success' })
              }
            })
          }
        },
    
        showDeleteFormDialog (item) {
          this.deleteFormObj = item
          this.deleteFormDialog = true
        },
    
        // 删除表单
        deleteApp () {
          this.$api
            .deleteApps(this.deleteAppObj.id)
            .then((res) => {
              //      this.getListData();
              this.initData()
              this.deleteAppDialog = false
              this.$message({ message: '删除成功', type: 'success' })
            })
            .catch(() => {
              // console.log(err)
            })
        },
        toSetting (schema) {
          this.showEditFormDialog(schema)
          // if (schema.type !== "T03") {
          //  this.$router.push({ name: "form_design", params: { id: schema.id } });
          // } else if (schema.type === "T03") {
          //  this.$router.push({
          //    name: "form_report",
          //    params: { id: schema.id, type: "report" },
          //  });
          // }
        },
        toDesign (schema) {
          if (schema.type !== 'T03') {
            this.$router.push({ name: 'form_design', params: { id: schema.id } })
          } else if (schema.type === 'T03') {
            this.$router.push({
              name: 'form_report',
              params: { id: schema.id, type: 'report' },
            })
          }
        },
        clickApp (app) {
          // console.log('clickApp', app)
          this.$router.push({ name: 'app', params: { app_id: app.id } })
        },
        book () {
          window.open('https://www.yuque.com/kuaidayun/help', '_blank')
        },
        signOut () {
          this.$s.commit('removeToken')
          this.$s.commit('removeProfile')
          this.$s.commit('removeTeam')
          this.$router.push({ name: 'login' })
        },
      },
    }
    </script>
    
    <style lang="scss" scoped>
    </style>
    